export default "__VITE_ASSET__Dp88iR7P__"